import { Breadcrumb } from 'antd';
import { useTranslation } from 'react-i18next';

import { DefaultLayout } from '@/component';
import { ContentHeader } from '@/views/order/create/ContentHeader';
import { List } from '@/views/order/create/List';

export const OrderCreatePage = () => {
  const { t } = useTranslation(['orderInfo']);

  return (
    <DefaultLayout>
      <DefaultLayout.Header>
        <Breadcrumb>
          <Breadcrumb.Item>{t('orderInfo:rootMenu')}</Breadcrumb.Item>
          <Breadcrumb.Item>{t('orderInfo:createPage.title')}</Breadcrumb.Item>
        </Breadcrumb>
      </DefaultLayout.Header>
      <DefaultLayout.Content>
        <ContentHeader />
        <List />
      </DefaultLayout.Content>
    </DefaultLayout>
  );
};
